import type { ReactNode } from 'react'
import { Link, usePage } from '@inertiajs/react'
import FlashMessages from '@/components/FlashMessages'

interface SystemAdminLayoutProps {
  children: ReactNode
}

interface AdminShared {
  admin_user: { id: number; email_address: string } | null
}

const NAV = [
  { label: 'Dashboard',     url: '/system_admin',               icon: 'lucide--gauge' },
  { label: 'Activation',    url: '/system_admin/funnel', icon: 'lucide--filter' },
  { label: 'Organizations', url: '/system_admin/accounts', icon: 'lucide--building-2' },
  { label: 'Users',         url: '/system_admin/users',         icon: 'lucide--users' },
  { label: 'Audit Log',     url: '/system_admin/audit-log',     icon: 'lucide--scroll-text' },
]

export default function SystemAdminLayout({ children }: SystemAdminLayoutProps) {
  const page = usePage()
  const adminUser = (page.props as unknown as AdminShared).admin_user

  const isActive = (url: string) =>
    url === '/system_admin' ? page.url === '/system_admin' : page.url.startsWith(url)

  return (
    <div className="min-h-screen flex bg-base-200">
      {/* Sidebar */}
      <aside className="w-56 shrink-0 bg-base-100 border-r border-base-300 flex flex-col">
        <div className="h-14 px-4 flex items-center gap-2 border-b border-base-300">
          <img src="/logo.svg" alt="" className="size-6" />
          <span className="font-bold">ImpactCheck</span>
          <span className="badge badge-soft badge-warning badge-sm">staff</span>
        </div>

        <ul className="menu w-full grow gap-0.5">
          <li className="menu-title text-xs uppercase tracking-wider">Operations</li>
          {NAV.map((item) => (
            <li key={item.url}>
              <Link href={item.url} className={isActive(item.url) ? 'menu-active' : ''}>
                <span className={`iconify ${item.icon} size-4`} />
                {item.label}
              </Link>
            </li>
          ))}
        </ul>

        <div className="border-t border-base-300 p-2">
          <a href="/" className="btn btn-ghost btn-sm w-full justify-start">
            <span className="iconify lucide--arrow-left size-4" />
            Exit to app
          </a>
        </div>
      </aside>

      {/* Main */}
      <div className="flex-1 flex flex-col min-w-0">
        <header className="h-14 bg-base-100 border-b border-base-300 px-4 flex items-center justify-between">
          <span className="text-sm font-semibold">System Admin</span>
          <span className="text-xs text-base-content/60">{adminUser?.email_address}</span>
        </header>

        <main className="grow p-4">
          <div className="max-w-7xl mx-auto space-y-6">
            <FlashMessages />
            {children}
          </div>
        </main>
      </div>
    </div>
  )
}
